import { render, staticRenderFns } from "./dynaView.vue?vue&type=template&id=5bef6dd8"
import script from "./dynaView.vue?vue&type=script&lang=js"
export * from "./dynaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports